import React, {useState} from 'react';
import styles from './date-selector.module.scss';
import DateLabel from '../date-label';
import {PopupCalendar} from '../../calendar';
import {Year} from '../../calendar/types';
import classNames from 'classnames';
import { Moment } from 'moment';
import {SVGS} from '../../../../assets/images';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props {
    value: Moment[]
    onComplete: (values: Moment[]) => void;
    range?: boolean;
    years?: Year[];
    minDate?: Moment;
    maxDate?: Moment;
    variant?: 'popup' | 'sheet';
    hidePresets?: boolean;
}

const DateSelector: React.FC<Props> = (props) => {
    const { years } = props;
    const isMobile = useMediaQuery('(max-width: 1000px)');
    const variant = props.variant ?? (isMobile ? 'sheet' : 'popup');
    const [value, setValue] = useState<Moment[]>(props.value);
    const [open, setOpen] = useState(false);

    const handleOnComplete = (range: [Moment, Moment | undefined | null]) => {
        const prep: Moment[] = [];
        prep.push(range[0])
        if (range[1]) {
            prep.push(range[1])
        }

        setValue(prep);
        props.onComplete(prep);
        setOpen(false);
    }
    
    const InputRenderer = () => {
        return (<div className={classNames({[styles.selector]: true, [styles.active]: open})}
            onClick={() => !open && setOpen(true)}>
            <div className={styles.label}>
                <DateLabel value={value[0]} type={'day'} small/>
                {
                    value.length > 1 && value[0] !== value[1] && <>
                        <span className={styles.dash}>–</span>
                        <DateLabel value={value[1]} type={'day'} small/>
                    </>
                }
            </div>
            <div className={classNames({[styles.actionFakeButton]: true, [styles.active]: open})}>
                <SVGS.CalendarIcon/>
            </div>
        </div>)
    };

    return (
        <>
            {
                !props.range && <PopupCalendar
                    years={years}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    view={'month'}
                    state={{open: open, setOpen: setOpen}}
                    onCalendarDateClick={(value) => handleOnComplete([value, undefined])}
                    value={value[0]}
                    renderer={<InputRenderer />}
                    disablePortal small
                    hidePresets={props.hidePresets}
                    variant={variant}/>
            }
            {
                !!props.range && <PopupCalendar range
                    years={years}
                    view={'month'}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    state={{open: open, setOpen: setOpen}}
                    value={[value[0], value[1]]}
                    onRangeComplete={handleOnComplete}
                    renderer={<InputRenderer />}
                    disablePortal small
                    hidePresets={props.hidePresets}
                    variant={variant}/>
            }
        </>)
}

export default DateSelector

